export default __webpack_public_path__ + "static/storv-bg-b8463cf75138c81a14c9a98f0f4e4bae.jpg";